// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryPosts-module--container--2SO69","posts":"CategoryPosts-module--posts--3t-zg","post":"CategoryPosts-module--post--2PD8v"};